import { useEffect, useRef } from "react"

export function useWindowMousePosition(cb?: (pos: { x: number; y: number }) => void) {
  const cbRef = useRef(cb)
  cbRef.current = cb

  function handleMouseMove(e: MouseEvent) {
    const position = { x: e.pageX, y: e.pageY }

    if (cbRef.current) {
      cbRef.current(position)
    }
  }

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove)

    return () => {
      window.removeEventListener("mousemove", handleMouseMove)
    }
  }, [])
}
